import React, { useState, useMemo } from "react";
import { Button } from "components/ui/button";
import ResumePreviewModal from "components/ResumePreviewModal";
import FileCloudinaryWidget from "components/CloudinaryWidget/FileCloudinaryWidget";
import ResumeWarningModal from "./ResumeWarningModal";
import { getUserName } from "utils/helpers/users";
import { useResumeUploadFlow } from "hooks/useResumeUploadFlow";
import { CTA_TITLES } from "components/UserCardList/constants/ctaTitles";
import SvgIcon from "components/base/SvgIcon";

const ResumeUpload = ({ user, save }) => {
  const [resumeDetails, setResumeDetails] = useState({
    resumeFileName: `${user.resumeLocation?.split("/")[2]}.pdf`,
    resumeLocation: user.resumeLocation,
  });

  const handleResumeUpload = async (resumeStorageLocation) => {
    await save({ resumeLocation: resumeStorageLocation });
    setResumeDetails({
      resumeFileName: `${resumeStorageLocation.split("/")[2]}.pdf`,
      resumeLocation: resumeStorageLocation,
    });
  };

  const {
    isPreviewModalOpen,
    isUploadWidgetOpen,
    isWarningModalOpen,
    setIsPreviewModalOpen,
    handleInitiateUpload,
    handleUploadComplete,
    handleClosePreview,
    handleCloseWarning,
    handleOpenWarningWidget,
    handleCloseUploadWidget,
  } = useResumeUploadFlow({
    onUploadSuccess: handleResumeUpload,
  });

  const previewUser = useMemo(
    () => ({
      ...user,
      resumeLocation: resumeDetails?.resumeLocation,
    }),
    [user, resumeDetails?.resumeLocation]
  );

  return (
    <>
      <Button
        variant="ghost"
        className="h-10 px-2 py-0"
        title={
          resumeDetails?.resumeLocation
            ? CTA_TITLES.downloadResume
            : CTA_TITLES.uploadResume
        }
        onClick={() => setIsPreviewModalOpen(true)}
      >
        <div className="flex items-center gap-2 text-gray-700 fill-gray-700 font-semibold">
          <SvgIcon
            type="binocular"
            className="h-5 w-5"
            aria-label={
              resumeDetails?.resumeLocation ? "Preview resume" : "Upload resume"
            }
          />
        </div>
      </Button>

      <ResumePreviewModal
        isOpen={isPreviewModalOpen}
        onClose={handleClosePreview}
        currentUser={previewUser}
        onInitiateUpload={handleInitiateUpload}
      />

      {isUploadWidgetOpen && (
        <FileCloudinaryWidget
          onUpload={handleUploadComplete}
          identifier="resume-upload-table"
          minImageHeight={517}
          minImageWidth={1839}
          resourceType="aspose"
          fileName={`${getUserName(user)}_resume`}
          icon="upload"
          tooltip="upload resume"
          openWidget={isUploadWidgetOpen}
          setLoadingWidget={handleCloseUploadWidget}
        />
      )}

      {isWarningModalOpen && (
        <ResumeWarningModal
          loadingWidget={isUploadWidgetOpen}
          onClose={handleCloseWarning}
          onUploadClickButton={handleOpenWarningWidget}
        />
      )}
    </>
  );
};

export default ResumeUpload;
